//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { APICall } from "../../../Helpers/Network/APICalls";
// import {} from "../../../Helpers/APIEndPoints/EndPoints";
import { useLocation } from "react-router-dom";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { useSelector } from "react-redux";
import notify from "../../../Helpers/ToastNotification";
import "./LoanInterest.css";
import { getLoanInterestDataById, insertUpdateLoanInterestData, getAllLoanTypeList } from "../../../Helpers/APIEndPoints/EndPoints";
import moment from "moment";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";

const LoanInterestEdit = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [roi, setROI] = useState("");
  const [loanType, setLoanType] = useState({});
  const [loanTypeOption, setLoanTypeOption] = useState([]);
  const context = useSelector((state: any) => state.updateReduxStore);

  const [formDataOnEdit, setFormDataOnEdit] = useState<any>({});
  const [isActive, setIsActive] = useState(true);
  const [editMode, setEditMode] = useState(false);

  // submit validation
  const [formErrors, setFormErrors] = useState({});
  // const [code, setCode] = useState("");
  let formErrorObj = {};

  useEffect(() => {
    (async () => {
      showLoader();
      setEditMode(true);
      getDropDownDataApiCall();
      if (state !== null && state.id && state.id > 0) {
        await getROIDataByIdF();
      }
      hideLoader();
    })();
  }, []);

  const getROIDataByIdF = async () => {
    let obj = {
      Id: state.id,
    };
    const resp = await APICall(getLoanInterestDataById, obj);
    if (resp?.Data?.Data?.length > 0) {
      setEditMode(false);
      setFormDataOnEdit(resp.Data.Data[0]);
      setROI(resp?.Data?.Data[0]?.ROI);
      setIsActive(resp?.Data?.Data[0]?.IsActive);
    }
  };

  const getDropDownDataApiCall = async () => {
    showLoader();

    const res = await APICall(getAllLoanTypeList);

    if (res && res.Data.length > 0) {
      let options = await res.Data;
      setLoanTypeOption(options);
      hideLoader();
    } else {
      setLoanTypeOption([]);
      notify(1, res.Message);
      hideLoader();
    }
  };

  useEffect(() => {
    if (loanTypeOption.length > 0 && formDataOnEdit.LoanType != "") {
      let val = loanTypeOption.find((ele) => ele.value == formDataOnEdit.LoanType);
      setLoanType(val);
    }
  }, [loanTypeOption, formDataOnEdit]);

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "loanType") {
      setLoanType(event);
    }
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!roi || roi === "") {
      formErrorObj["ROI_isEmpty"] = "Interest Rate can not be empty";
    } else if (roi.length > 100) {
      formErrorObj["ROI_isEmpty"] = "Interest Rate must be less than 100 characters";
    }
    if (!loanType || Object.keys(loanType).length <= 0) {
      formErrorObj["loanType_isEmpty"] = "Please select loan type";
    }
    // if (!code || code === "") {
    //   formErrorObj["Code_isEmpty"] = "Code can not be empty";
    // }
    setFormErrors(formErrorObj);
  };

  const onClickFunction = async (action: any) => {
    showLoader();
    if (action === "Submit") {
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        return f === "" || f === null || f === undefined;
      });
      if (isEmpty === true) {
        let param = {
          Id: state.id != null || state.id != 0 ? state.id : 0,
          ROI: roi,
          LoanType: loanType.value,
          IsActive: isActive,
          CreatedBy: context.Id,
          CreatedDateUtc: moment(new Date()).format(moment.HTML5_FMT.DATETIME_LOCAL),
        };
      

        const insertData = await APICall(insertUpdateLoanInterestData, param);
        if (insertData?.Data?.Status == ApiStatus.Error) {
          const errors = insertData?.Data?.Data;
          const errorComponent = Array.isArray(errors) ? <div dangerouslySetInnerHTML={{ __html: errors?.join("<br />") }} /> : errors;
          notify(1, errorComponent);
        } else if (insertData?.Status == ApiStatus.Error) {
          notify(1, insertData?.Data);
        } else if (insertData?.Data != null) {
          if (state !== null && state.id && state.id > 0) {
            notify(0, "Rate of interest successfully updated");
          } else {
            notify(0, "Rate of interest successfully inserted");
          }
          navigate(-1);
        }
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      navigate(-1);
    }
    hideLoader();
  };

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    const regex = /^[0-9]+(.+)?$/;
    if (field === "roi") {
      if (value === "" || regex.test(parseFloat(value))) {
        if (value.length > 5) {
          value = value.slice(0, 5);
        }
        if (value <= 100) {
          setROI(value);
        }
      }
    }
    // if (field === "code") {
    //   if (value === "" || regex.test(value)) {
    //     if (value.length > 10) {
    //       value = value.slice(0, 10);
    //     }
    //     setCode(value);
    //   }
    // }
  };

  const resetFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setROI("");
    // setCode("");
    setLoanType({});
  };

  return (
    <>
      <div>
        <div className="">
          <div className="col-lg-12 col-md-12 p-0">
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Loan Type</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <SelectForm
                  options={loanTypeOption}
                  isDisabled={editMode ? false : true}
                  isMulti={false}
                  placeholder={""}
                  value={loanType}
                  onChange={(event: any) => selectOnChange(event, "loanType")}
                />
                <p style={{ color: "red" }}>{formErrors["loanType_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Interest Rate</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  
                  placeholder={""}
                  value={roi}
                  onChange={(e) => handleTextEvent(e, "roi")}
                  textArea={false}
                  onKeyPress={(e) => handleKeyPress(e)}
                />
                <p style={{ color: "red" }}>{formErrors["ROI_isEmpty"]}</p>
              </div>
              {/* <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Code</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  disabled={editMode ? true : false}
                  placeholder={""}
                  value={code}
                  onChange={(e) => handleTextEvent(e, "code")}
                  onKeyPress={(e) => handleKeyPress(e)}
                  textArea={false}
                />
                <p style={{ color: "red" }}>{formErrors["Code_isEmpty"]}</p>
              </div> */}
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
                <div className="form-group">
                  <label className="col-form-label">Active Status</label>
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      disabled={editMode ? true : false}
                      type="checkbox"
                      onChange={(e) => setIsActive(e.target.checked)}
                      name="isActive"
                      checked={isActive}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-2">
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value={<p><i className="fas fa-paper-plane"></i> Submit</p> } onClick={() => onClickFunction("Submit")} />
          </div>
          {/* <div>
            <ButtonForm className="btn btn-info" id="Reset" style={{ marginLeft: 5 }} value="Reset" onClick={() => onClickFunction("Reset")} />
          </div> */}
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value={<p><i className="far fa-times-circle"></i> Cancel</p> } onClick={() => navigate("/master/LoanInterest")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanInterestEdit;
